import ReviewsCarousel from './ReviewsCarousel';
import TelStoreCover from './TelStoreCover';
import ReviewAuthor from './ReviewAuthor';
import { useState } from 'react';

import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import { RedesignFooter, RedesignHeader, RedesignPage, SiteLink } from './RedesignShell';

const websiteTypes = [
  {
    href: '/services/websites/corporate/',
    title: 'Корпоративные сайты',
    text: 'Разработка корпоративного сайта помогает представить компанию, услуги и повысить доверие клиентов. Такой сайт усиливает бренд и привлекает трафик из поиска.',
  },
  {
    href: '/services/websites/ecommerce/',
    title: 'Интернет-магазины',
    text: 'Создание интернет-магазина включает каталог товаров, фильтры, корзину и онлайн-оплату. Выполняется интеграция с CRM, 1С и внешними сервисами.',
  },
  {
    href: '/services/websites/landing/',
    title: 'Лендинги (Landing Page)',
    text: 'Одностраничный сайт подходит для рекламы и быстрых продаж. Лендинг фокусируется на одном продукте и высокой конверсии.',
  },
  {
    href: '/services/websites/seo/',
    title: 'Разработка под SEO',
    text: 'Сайт создается с учетом поисковых запросов и требований поисковых систем. Это позволяет быстрее получать органический трафик.',
  },
  {
    href: '/services/websites/redesign-support/',
    title: 'Редизайн и поддержка сайтов',
    text: 'Если текущий сайт устарел, выполняется редизайн и доработка. Улучшается структура, дизайн и скорость загрузки.',
  },
];

const technologies = [
  ['Frontend', 'Адаптивная верстка и современный интерфейс. Сайт корректно работает на всех устройствах.'],
  ['Backend', 'Надежная серверная часть. Обработка данных, безопасность и высокая скорость загрузки.'],
  ['CMS и фреймворки', 'Используются WordPress, 1С-Битрикс и другие системы управления. Это обеспечивает удобство работы с контентом.'],
  ['Интеграции и API', 'Подключение CRM, платежных систем, аналитики и внешних сервисов. Автоматизация бизнес-процессов.'],
];

const creationSteps = [
  ['Аналитика и погружение в бизнес', 'Проводится анализ ниши, конкурентов и целевой аудитории. Формируется техническое задание.'],
  ['UX/UI дизайн', 'Создаются прототипы и дизайн-макеты. Прорабатывается структура и логика страниц.'],
  ['Разработка и тестирование', 'Выполняется программирование, верстка и настройка функционала. Проводится тестирование и исправление ошибок.'],
  ['Запуск и оптимизация', 'Сайт размещается на хостинге, подключаются системы аналитики и выполняется SEO-оптимизация.'],
];

const approachItems = [
  ['Работаем по Agile / Scrum', 'Проект делится на этапы. Можно вносить изменения в процессе разработки.'],
  ['Прозрачные этапы и сроки', 'Клиент видит весь процесс разработки сайта и контролирует результат.'],
  ['Фокус на конверсии', 'Каждый элемент сайта направлен на получение заявок и продаж.'],
];

const collaborationFormats = [
  ['Проектная разработка', 'Фиксированный объем работ и сроки выполнения.'],
  ['Выделенная команда', 'Команда специалистов работает только над вашим проектом.'],
  ['Почасовая работа', 'Подходит для доработок и поддержки сайта.'],
];

const deliverables = [
  ['Готовый к продвижению сайт', 'Сайт создается с учетом SEO и требований поисковых систем.'],
  ['Быструю загрузку и SEO-оптимизацию', 'Оптимизированная структура и высокая скорость работы.'],
  ['Удобную админ-панель', 'Управление контентом без программиста.'],
  ['Масштабируемую архитектуру', 'Возможность развития и добавления нового функционала.'],
];

const supportItems = [
  ['Техническая поддержка', 'Контроль работы сайта и устранение ошибок.'],
  ['SLA и гарантии', 'Фиксированные сроки реакции и выполнения задач.'],
  ['Доработки и развитие', 'Добавление новых функций и улучшение проекта.'],
  ['SEO и продвижение', 'Увеличение трафика и количества заявок.'],
];

const priceFactors = ['структура и количество страниц', 'функционал и интеграции', 'дизайн и уровень проработки', 'сроки реализации'];

const priceRows = [
  'Корпоративный сайт — от 50.000 рублей',
  'Лендинг — от 35.000 рублей',
  'Интернет-магазин — от 200.000 рублей',
];

const relatedServices = [
  { href: '/services/seo/full-cycle/', title: 'SEO-продвижение сайтов' },
  { href: '/services/mini-apps/', title: 'Разработка Mini App' },
  { href: '/services/mobile/', title: 'Разработка веб-приложений' },
  { href: '/services/yandex-maps/', title: 'Продвижение в Яндекс.Картах' },
];

const reviews = [
  [
    'Александр, строительная компания',
    '«Обратились за разработкой сайта под ключ. Старый сайт не приносил заявок. После запуска нового сайта: вырос трафик, начали приходить клиенты из поиска. Сейчас сайт реально работает как инструмент продаж.»',
  ],
  [
    'Марина, интернет-магазин одежды',
    '«Заказывали создание интернет-магазина. Сделали каталог, оплату, интеграцию с CRM. После запуска увеличились продажи и упростилась работа с заказами.»',
  ],
  [
    'Игорь, B2B услуги',
    '«Нужен был лендинг под рекламу. Сделали структуру и дизайн с фокусом на конверсию. В итоге снизилась стоимость заявки и вырос поток клиентов.»',
  ],
  [
    'Ольга, услуги',
    '«Обратились за редизайном сайта. После обновления улучшился дизайн, снизились отказы и появились заявки.»',
  ],
];

const faqItems = [
  ['Сколько стоит разработка сайта?', 'Стоимость зависит от задач, функционала и сложности проекта. Оставьте заявку — подготовим расчет.'],
  ['Сроки создания сайта?', 'От 2 недель до нескольких месяцев в зависимости от проекта.'],
  ['Что нужно для старта?', 'Достаточно описать задачу. Команда поможет сформировать решение.'],
  ['Будет ли сайт продвигаться в SEO?', 'Да, разработка выполняется с учетом требований поисковых систем.'],
  ['Почему стоит заказать сайт под ключ?', 'Это экономит время, снижает риски и дает готовый результат без доработок.'],
];

function BulletList({ items }) {
  return (
    <ul className="source-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

function SectionHeader({ title, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <h2>{title}</h2>
      </div>
      {description && <p className="sub">{description}</p>}
    </div>
  );
}

function WebsitesCategoryPage() {
  const [openFaq, setOpenFaq] = useState(-1);

  return (
    <RedesignPage>
      <PageMeta
        title="Разработка сайтов под ключ - заказать разработку веб-сайта для бизнеса"
        description="Закажите разработку сайта любой сложности под ключ. Создание веб-сайта на заказ по выгодной цене и под цели Вашего бизнеса. Системный подход, множество кейсов и команда профессионалов. Рассчитайте стоимость в студии fatalitystudio.ru или по телефону +7 (925) 653-04-54 !"
      />
      <RedesignHeader />

      <section className="ink service-hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-340px', width: '980px', height: '980px', opacity: 0.1 }}
        />
        <div className="container">
          <div>
            <h1>Разработка сайтов под ключ</h1>
            <p className="hero-sub">
              Разработка сайтов под ключ — это создание не просто веб-страниц, а полноценного инструмента для бизнеса.
              Такой сайт привлекает клиентов, увеличивает трафик и помогает стабильно получать заявки.
            </p>
            <p className="service-hero-copy">
              Компания предоставляет услуги по разработке сайтов любой сложности: от лендингов до интернет-магазинов и
              корпоративных порталов. Каждый проект создается с учетом целей бизнеса, особенностей ниши и поведения
              пользователей.
            </p>
            <p className="service-hero-copy">
              Используется комплексный подход: аналитика, проектирование структуры сайта, дизайн, программирование и
              SEO-оптимизация. Это позволяет создать сайт, который не просто существует, а работает на результат.
            </p>
            <p className="service-hero-copy">Оставьте заявку — покажем, каким может быть ваш сайт и сколько он будет приносить.</p>
            <div className="hero-ctas">
              <SiteLink href="#websites-category-lead" className="btn btn-primary">
                Заработать на сайте
              </SiteLink>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— проектирование"
            title="Спроектируем сайт, который приносит заявки"
            description="Главная задача разработки сайта — создание инструмента продаж. Дизайн, структура и контент работают на конверсию и привлечение клиентов."
          />
          <div className="split-proof">
            <div>
              <p>
                Перед началом разработки проводится анализ бизнеса, целевой аудитории и конкурентов. Это позволяет
                создать решение, которое соответствует реальным задачам компании.
              </p>
              <p>В процессе проектирования учитываются:</p>
              <BulletList
                items={[
                  'поведение пользователей и сценарии взаимодействия',
                  'ключевые запросы и SEO-структура',
                  'логика страниц и навигация',
                  'элементы, влияющие на конверсию',
                ]}
              />
            </div>
            <div>
              <p>В результате создается сайт, который:</p>
              <BulletList
                items={['понятен пользователям', 'адаптивен под все устройства', 'быстро загружается', 'готов к SEO-продвижению']}
              />
              <p>Такой подход позволяет сразу получать заявки, а не дорабатывать сайт после запуска.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— виды сайтов"
            title="Какие сайты мы разрабатываем"
            description="Услуги по созданию сайтов охватывают все основные направления. Можно заказать разработку сайта под конкретные задачи бизнеса."
          />
          <div className="svc-grid website-type-grid">
            {websiteTypes.map((item) => (
              <SiteLink href={item.href} className="svc" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </SiteLink>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            dark
            eyebrow="— технологии"
            title="Технологии, которые работают на результат"
            description="Разработка веб-сайтов выполняется с использованием современных технологий и проверенных решений."
          />
          <div className="tech-tiles">
            {technologies.map(([title, text]) => (
              <div className="tech-tile" key={title}>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— процесс"
            title="Как мы создаём сайты: от идеи до запуска"
            description="Процесс создания сайта разбит на этапы. Это позволяет контролировать сроки и качество."
          />
          <div className="process-rail process-rail-five">
            {creationSteps.map(([title, text]) => (
              <div className="process-step" key={title}>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
          <p className="section-note">На каждом этапе вы понимаете, что происходит и за что платите.</p>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— подход"
            title="Подход к разработке, который экономит бюджет"
            description="Работа строится так, чтобы клиент получал результат без лишних затрат."
          />
          <div className="compact-card-grid">
            {approachItems.map(([title, text]) => (
              <div className="compact-card" key={title}>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader dark eyebrow="— форматы" title="Форматы сотрудничества" />
          <p className="service-hero-copy">Можно выбрать удобный формат работы в зависимости от задач.</p>
          <div className="compact-card-grid">
            {collaborationFormats.map(([title, text]) => (
              <div className="compact-card interactive-card" key={title}>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader eyebrow="— результат" title="Что вы получаете в итоге" description="Разработка сайта — это готовое решение для бизнеса." />
          <div className="compact-card-grid">
            {deliverables.map(([title, text]) => (
              <div className="compact-card" key={title}>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
          <p className="section-note">В результате вы получаете не просто сайт, а систему привлечения клиентов.</p>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader eyebrow="— поддержка" title="Поддержка и развитие после запуска" description="После запуска сайт продолжает развиваться." />
          <div className="compact-card-grid">
            {supportItems.map(([title, text]) => (
              <div className="compact-card" key={title}>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader eyebrow="— стоимость" title="Сколько стоит разработка сайта" description="Стоимость разработки сайта зависит от задач и сложности проекта." />
          <div className="pricing-layout">
            <div className="price-list">
              <h3 className="pricing-subhead">От чего зависит стоимость</h3>
              <BulletList items={priceFactors} />
              <h3 className="pricing-subhead">Примерные диапазоны цен</h3>
              {priceRows.map((price) => (
                <div className="price-row" key={price}>
                  <span>{price}</span>
                </div>
              ))}
            </div>
            <div className="price-note">
              <h3>Как мы рассчитываем стоимость</h3>
              <p>Проводится анализ проекта и составляется смета с учетом всех этапов разработки.</p>
              <h3>Получить оценку проекта</h3>
              <p>Оставьте заявку — расчет стоимости занимает 1 день.</p>
              <SiteLink href="#websites-category-lead" className="btn btn-primary">
                Рассчитать сайт за 1 день
              </SiteLink>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader eyebrow="— рядом" title="Похожие услуги" />
          <div className="related-grid">
            {relatedServices.map((item) => (
              <SiteLink href={item.href} className="related-card" key={item.title}>
                <span>{item.title}</span>
              </SiteLink>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader dark eyebrow="— кейсы" title="Кейсы: сайты, которые уже работают и зарабатывают" />
          <h3 className="standalone-h3 ink-standalone">Примеры с результатами (трафик, заявки)</h3>
          <p className="service-hero-copy">Проекты показывают рост трафика, увеличение заявок и улучшение конверсии.</p>
          <SiteLink href="/portfolio/tech-store/" className="case-teaser section-action case-teaser-telstore">
            <TelStoreCover preview wide alt="" />
            <div className="case-teaser-body">
              <div className="case-card-title">Создание интернет-магазина техники в Москве</div>
              <p>Разработка интернет-магазина техники под ключ для рынка Москва.</p>
              <p>Проект включал полный цикл: от создания сайта с нуля до SEO-продвижения и запуска рекламы.</p>
            </div>
          </SiteLink>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader eyebrow="— отзывы" title="Отзывы клиентов о разработке сайтов" />
          <ReviewsCarousel className="reviews-grid reviews-grid-two">
            {reviews.map(([name, text]) => (
              <figure className="review-card" aria-label={name} key={name}>
                <blockquote>{text}</blockquote>
                <ReviewAuthor label={name} />
              </figure>
            ))}
          </ReviewsCarousel>
          <p className="section-note">Хотите такой же результат? Оставьте заявку — разберем ваш проект.</p>
        </div>
      </section>

      <section className="ink lead" id="websites-category-lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <LeadForm
            formId="websites-category-lead-form"
            idPrefix="websites-category"
            eyebrow="Форма заявки"
            contactLabel="Телефон"
            contactType="tel"
            contactPlaceholder="+7 (___) ___-__-__"
            submitLabel="Рассчитать сайт за 1 день"
            taskPlaceholder="Опишите задачу для сайта"
          />
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader eyebrow="— материалы" title="Полезные материалы о разработке сайтов" />
          <div className="compact-card-grid">
            <div className="compact-card">
              <h3>Статьи</h3>
              <p>Материалы о создании сайтов, SEO и интернет-маркетинге.</p>
            </div>
            <div className="compact-card">
              <h3>Видео и разборы</h3>
              <p>Практические кейсы и рекомендации специалистов.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <div className="faq-grid">
            <div>
              <h2 className="standalone-h2">Ответы на частые вопросы</h2>
            </div>
            <div className="faq-list">
              {faqItems.map(([question, answer], index) => {
                const isOpen = openFaq === index;
                return (
                  <div className={`faq-item${isOpen ? ' open' : ''}`} key={question}>
                    <h3>
                      <button
                        className="faq-q"
                        type="button"
                        onClick={() => setOpenFaq(isOpen ? -1 : index)}
                        aria-expanded={isOpen}
                        aria-controls={`websites-faq-answer-${index}`}
                      >
                        <span>{question}</span>
                        <span className="faq-toggle" aria-hidden="true" />
                      </button>
                    </h3>
                    <div className="faq-a" id={`websites-faq-answer-${index}`} aria-hidden={!isOpen}>
                      <div className="faq-a-inner">
                        <p>{answer}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default WebsitesCategoryPage;
